
import { defineComponent,computed,reactive,toRefs } from 'vue'
import { useRouter } from 'vue-router'
import { isExternal } from '@/utils/validate'
import {openNewWindow} from '@/utils/utils'
import { Inspectopen } from "@/mixins/Inspectopen";
import LiveClassroomApi from "@/apis/liveClassroomApi";
import { store } from '@/store'
import { ElMessage } from "element-plus";

export default defineComponent({
  props: {
    to: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const data: any = reactive({
    appInfo : null,
    ticket : '',
    userInfo: computed(() => store.state.user.userInfo.userinfo),
    })
    const router = useRouter()
    const push = () => {
      router.push(props.to).catch((err) => {
        console.log(err)
      })
    }
    //跳转到某个新的页面
    const goTO = (url: string) => {
      if (props.name == '巡课统计' || props.name == '巡课记录') {
        getAppInfo().then(()=>{
          if (data.appInfo && data.ticket) {
            let ip = data.appInfo.domain
            let  params={
              tickets: data.ticket as string,
              userName:data.userInfo.account as string,
              teacherName:data.userInfo.username as string,
            }
            LiveClassroomApi.getAccessUrl(ip,params).then((res:any)=>{
              if(props.name == '巡课统计'){
                openNewWindow(res.data.ReportUrl)
              }else if(props.name == '巡课记录'){
                openNewWindow(res.data.ReportListUrl)
              }
            })
          }else{
            ElMessage.error('访问失败，请检查是否为校内网络！');
          }
        })
      }else if(props.name == '线下（教室）督导巡课'){
        openNewWindow("/#/inspectopen/classRoomStatisticsCourseList?classmonitor=1");
      }
      else{
       openNewWindow(url)
      }
    }
    const getAccessUrl = async () => {

    }
    const getAppInfo = async() => {
        //先获取当前机构的信息，未开通的返回为空
        data.appInfo =  await LiveClassroomApi.getAppInfo() as any
        if (data.appInfo) {
            //获取缓存票据信息
            data.ticket =   await LiveClassroomApi.getTicketCache() as string
            if (!data.ticket) {
                //如果未获取到缓存信息重新获取
                await LiveClassroomApi.getTickets(data.appInfo.domain, { appid: data.appInfo.appid, appsecret: data.appInfo.appsecret }).then((res: any) => {
                    data.ticket = res.data
                    //保存当前最新ticket到缓存
                    LiveClassroomApi.saveTicketToCache({ ticket: res.data })
                })
            }
        }
    };
    return {
      ...toRefs(data),
      push,
      isExternal,
      goTO
    }
  }
})
